import { createReducer } from '../lib/createReducer.js';
import { mergeByProp } from '@shared/utils/mergeByProp.js';

const initialState = {
  integrations: [],
  provisionedCredential: null,
  hasFetchedMetadata: false,
  credentialExchangeCustomAuthFields: []
};

export default createReducer(initialState, {
  GET_INTEGRATIONS_METADATA_SUCCESS: (state, payload) => ({
    ...state,
    integrations: payload?.data || [],
    hasFetchedMetadata: true
  }),

  CREATE_INTEGRATION_SUCCESS: (state, payload) => ({
    ...state,
    integrations: [payload?.data, ...state.integrations]
  }),

  UPDATE_INTEGRATION_SUCCESS: (state, payload) => ({
    ...state,
    integrations: mergeByProp('id', state.integrations, [payload?.data], (existing, incoming) => ({
      ...existing,
      ...incoming
    }))
  }),

  DELETE_INTEGRATION_SUCCESS: (state, payload) => ({
    ...state,
    integrations: state.integrations.filter((integration) => integration.id !== payload?.data?.id)
  }),

  GET_INTEGRATION_SUCCESS: (state, payload) => ({
    ...state,
    integrations: mergeByProp('id', state.integrations, [payload?.data], (existing, incoming) => ({
      ...existing,
      ...incoming
    }))
  }),

  GET_INTEGRATION_WORKFLOWS_SUCCESS: (state, payload) => ({
    ...state,
    integrations: mergeByProp(
      'id',
      state.integrations,
      [
        {
          id: payload?.meta?.integrationId,
          workflows: payload?.data || []
        }
      ],
      (existing, incoming) => ({
        ...existing,
        ...incoming
      })
    )
  }),

  REMOVE_WORKFLOW_FROM_INTEGRATION_SUCCESS: (state, payload) => ({
    ...state,
    integrations: state.integrations.map((integration) => {
      if (integration.id === payload?.data?.integrationId) {
        return {
          ...integration,
          workflows: (integration.workflows || []).filter((workflow) => workflow.id !== payload?.data?.workflowId)
        };
      }
      return integration;
    })
  }),

  RENAME_INTEGRATION_APP_SUCCESS: (state, payload) => ({
    ...state,
    integrations: state.integrations.map((integration) => {
      if (integration.id === payload?.meta?.integrationId) {
        return { ...integration, apps: payload?.data?.apps || [] };
      }
      return integration;
    })
  }),

  DELETE_INTEGRATION_APP_SUCCESS: (state, payload) => ({
    ...state,
    integrations: state.integrations.map((integration) => {
      if (integration.id === payload?.meta?.integrationId) {
        return { ...integration, apps: payload?.data?.apps || [] };
      }
      return integration;
    })
  }),

  DELETE_INSTALLATION_SUCCESS: (state, payload) => ({
    ...state,
    integrations: state.integrations.map((integration) => {
      if (integration.id === payload?.meta?.integrationId) {
        return {
          ...integration,
          endUsers: (integration.endUsers || []).filter((endUser) => endUser.id !== payload?.meta?.installationId)
        };
      }
      return integration;
    })
  }),

  GET_WORKFLOW_STATE_SUCCESS: (state, payload) => {
    if (!payload?.data?.integration) {
      return state;
    }

    return {
      ...state,
      integrations: mergeByProp('id', state.integrations, [payload.data.integration], (existing, incoming) => ({
        ...existing,
        ...incoming
      }))
    };
  },

  UPSERT_PROVISIONED_CREDENTIAL_SUCCESS: (state, payload) => ({
    ...state,
    provisionedCredential: payload?.data || null
  }),

  UPSERT_PROVISIONED_CREDENTIAL_ERROR: (state) => ({
    ...state,
    provisionedCredential: null
  }),

  SET_CREDENTIAL_EXCHANGE_CUSTOM_AUTH_FIELDS: (state, payload) => ({
    ...state,
    credentialExchangeCustomAuthFields: payload || []
  }),

  UPDATE_INSTALLATION_METADATA_SUCCESS: (state, payload) => ({
    ...state,
    integrations: state.integrations.map((integration) =>
      integration.endUsers?.some((u) => u.id === payload?.meta?.installationId)
        ? {
            ...integration,
            endUsers: (integration.endUsers || []).map((endUser) => (endUser.id === payload?.meta?.installationId ? { ...endUser, metadata: payload?.data?.metadata || payload?.meta?.metadata || {} } : endUser))
          }
        : integration
    )
  })
});
